import * as React from "react";
import { forwardRef } from "react";
const SvgPools = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 10C6 7.79086 7.79086 6 10 6H30C32.2091 6 34 7.79086 34 10V30C34 32.2091 32.2091 34 30 34H10C7.79086 34 6 32.2091 6 30V10ZM30 10L10 10V30H30V10Z", fill: "#94A3B8" }), /* @__PURE__ */ React.createElement("path", { d: "M8 24H14L16 28H24L26 24H32V32H8V24Z", fill: "#94A3B8" }));
const ForwardRef = forwardRef(SvgPools);
export { ForwardRef as ReactComponent };
